import Chart from 'react-apexcharts';
import React from 'react';

const brLocale = {
  name: 'pt-BR',
  options: {
    months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    shortMonths: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    days: ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'],
    shortDays: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    toolbar: {
      download: 'Baixar SVG',
      selection: 'Seleção',
      selectionZoom: 'Zoom na Seleção',
      zoomIn: 'Aumentar Zoom',
      zoomOut: 'Diminuir Zoom',
      pan: 'Panorâmica',
      reset: 'Resetar Zoom',
    }
  }
}

export default ({ series = [], height = '', width = '', title = '', events = { dataPointSelection: () => { } }, customIcons = [] }) => (
  <Chart height={height} width={width} series={[{ data: series[0]?.data?.sort ? series[0]?.data?.sort((a, b) => b.y - a.y) : series[0]?.data }]} type='treemap' options={{
    chart: {
      locales: [brLocale],
      defaultLocale: 'pt-BR',
      id: 'chart-' + title.replace(' ', '-').toLowerCase(),
      background: 'rgb(35, 35, 35)',
      events: events,
      toolbar: {
        tools: {
          customIcons: customIcons,
          pan: false,
          reset: false,
        }
      }
    },
    title: {
      text: title,
    },
    xaxis: {
      tickPlacement: true,
    },
    yaxis: {
      labels: {
        formatter: value => 'R$' + value.toLocaleString('pt-BR')
      },
    },
    theme: {
      mode: 'dark',
      palette: 'palette2',
    },
    // colors: [
    //   '#3B93A5',
    //   '#F7B844',
    //   '#ADD8C7',
    //   '#EC3C65',
    //   '#CDD7B6',
    //   '#C1F666',
    //   '#D43F97',
    //   '#1E5D8C',
    //   '#421243',
    //   '#7F94B0',
    //   '#EF6537',
    //   '#C0ADDB'
    // ],
    stroke: {
      show: false
    },
    plotOptions: {
      treemap: {
        distributed: true
      }
    },
    tooltip: {
      y: {
        formatter: value => 'R$' + value.toLocaleString('pt-BR')
      },
    }
  }} />
)